export const tipoCampoMap = {
    "radio":    0,   // RespostaUnica
    "checklist": 1,  // MultiplaEscolha
    "number":   2,   // Numerico
    "text":     3,   // Textual
    "select":   4,   // Select
    "file":     5,   // Anexo,
    "foto":     6,    // Foto - Camera
    "date":     7
  };

export const revertedTipoCampoMap = Object.fromEntries(
    Object.entries(tipoCampoMap).map(([key, value]) => [value.toString(), key]));

export const prepareData = (data) => {
    let titulosTemp = {};
    const dados = (data ?? []).map(e => {
        if(!titulosTemp[e.title])
            titulosTemp[e.title] = e.title
        
        return {
        ...e,
        nome: e.cliente?.razaoSocial || e.cliente?.nomeFantasia || "",
        codigo: e.cliente?.codigo || e.cliente?.codigoProspect || "",
        toFilterName: (`${e.cliente?.codigo || e.cliente?.codigoProspect} - ${e.cliente?.razaoSocial || e.cliente?.nomeFantasia}`)?.toLowerCase(),
        status: e.dataResposta ? "Pesquisado" : "Não Pesquisado",
        pesquisa: e.pesquisa?.map(p => (
            {
            ...p,
            originalType: p.type,
            type: revertedTipoCampoMap[p.type] ?? p.type,
            }
        ))
        }
    })

    return {
        titulos: Object.values(titulosTemp),
        dados
    }
}